import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter } from 'rxjs';
import { DrawerService } from './services/drawer.service';
import { SeoData, TitleService } from './services/title.service';

@Component({
  selector: 'main[app-root]',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor(
    private titleService: TitleService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private drawerService: DrawerService
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.titleService.setPageMeta(
          this.getActiveSeoData(),
          event.urlAfterRedirects
        );
        this.dialog.closeAll();
        this.drawerService.closeMenu();
        this.drawerService.closeCart();
      });
  }

  private getActiveSeoData(): SeoData | undefined {
    let route = this.activatedRoute.firstChild;
    let seo = route?.snapshot.data['seo'] as SeoData | undefined;

    while (route?.firstChild) {
      route = route.firstChild;
      seo = (route.snapshot.data['seo'] as SeoData | undefined) ?? seo;
    }

    return seo;
  }
}
